module.exports = "<div *ngIf=\"recordsCount >= 0\">\n  <div class=\"row\">\n    <div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-12\">\n      <div *ngIf=\"error\" class=\"alert alert-danger\">No se puede descargar un excel con mas de {{ maxRecordsAllowed }} registros</div>\n    </div>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/export/export-view/export-view.component.html
// module id = ./src/app/export/export-view/export-view.component.html
// module chunks = main